import { styled } from 'styled-components';

interface Props {
  position: string;
  $sidebar: boolean;  // Alterado para $sidebar
}

export const Container = styled.div<Props>`
  
  ${props => {
    const forSideBar = props.$sidebar ? `
        display: grid; 
        gap: 0px 0px; 
    ` : "";

    if (props.position == 'left') {
      return `
        ${forSideBar}
        grid-template-columns: 0.01fr 1fr;
        grid-template-rows: 0.01fr 1fr;
        grid-template-areas:
          "Sidebar Header"
          "Sidebar Content";
      `;
    }
    else {
      return `
        ${forSideBar}
        grid-template-columns: 1fr;
        grid-template-rows: 5fr;
        grid-template-areas:
          "Header Header"
          "Content Content";
      `;
    }
  }}

  height: 100vh;
  width: 100vw;
  background-color: white;


`;


export const ContainerHeader = styled.div`
  grid-area: Header;
`;

export const ContainerSidebar = styled.div`
  grid-area: Sidebar;

  @media (max-width: 630px) {
    display: none;
  }
`;

export const ContainerOutlet = styled.div`
  grid-area: Content;

`;
